import enMessages from "./en"
import ruMessages from "./ru"

export const en = enMessages
export const ru = ruMessages
